import api from '../../utils/axios';

const state = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    state.isAuthenticated = !!user;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  UPDATE_USER_PROFILE(state, profile) {
    if (state.user) {
      state.user = { ...state.user, ...profile };
    }
  }
};

const actions = {
  // 登录
  async login({ commit }, { identifier, password }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.post('/auth/login', { identifier, password });
      const { token, user } = response;
      
      // 保存token到localStorage
      localStorage.setItem('token', token);
      
      // 更新状态
      commit('SET_USER', user);
      
      return user;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '登录失败，请重试';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 登出
  logout({ commit }) {
    localStorage.removeItem('token');
    commit('SET_USER', null);
  },
  
  // 检查认证状态
  async checkAuth({ commit, dispatch }) {
    const token = localStorage.getItem('token');
    if (!token) {
      commit('SET_USER', null);
      return false;
    }
    
    try {
      // 获取用户信息
      await dispatch('fetchUserProfile');
      return true;
    } catch (error) {
      // 如果获取用户信息失败，清除token
      localStorage.removeItem('token');
      commit('SET_USER', null);
      return false;
    }
  },
  
  // 获取用户信息
  async fetchUserProfile({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.get('/auth/profile');
      commit('SET_USER', response);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取用户信息失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 更新用户信息
  async updateUserProfile({ commit }, userData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.put('/auth/profile', userData);
      commit('SET_USER', response);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '更新用户信息失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 修改密码
  async changePassword({ commit }, { currentPassword, newPassword }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.put('/auth/change-password', { 
        currentPassword, 
        newPassword 
      });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '修改密码失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 提交反馈
  async submitFeedback({ commit }, { content }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.post('/auth/feedback', { content });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '提交反馈失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 获取用户反馈回复
  async getUserFeedback({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await api.get('/auth/feedback');
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取反馈信息失败';
      commit('SET_ERROR', errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  currentUser: state => state.user,
  isLoading: state => state.loading,
  error: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 